import { render, staticRenderFns } from "./pricequeryView.vue?vue&type=template&id=5ff7546c&scoped=true"
import script from "./pricequeryView.vue?vue&type=script&lang=js"
export * from "./pricequeryView.vue?vue&type=script&lang=js"
import style0 from "./pricequeryView.vue?vue&type=style&index=0&id=5ff7546c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff7546c",
  null
  
)

export default component.exports